var map = {
	"./ar-SA.json": [
		3705,
		3705
	],
	"./es-ES.json": [
		22852,
		22852
	],
	"./fa-IR.json": [
		27377,
		27377
	],
	"./fr-CA.json": [
		91569,
		91569
	],
	"./fr-FR.json": [
		24597,
		24597
	],
	"./ko-KR.json": [
		46394,
		46394
	],
	"./pt-PT.json": [
		36318,
		36318
	],
	"./ru-RU.json": [
		27947,
		27947
	],
	"./zh-hans.json": [
		53402,
		53402
	],
	"./zh-hant.json": [
		54475,
		54475
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19026;
module.exports = webpackAsyncContext;